import {
  LOAD_PIXEL_SERVER
} from 'constants/reduxActions';

export default function pixelServerReducer(state = {}, action) {
  const { data, pageType, queryString, type } = action;
  switch (type) {
    case LOAD_PIXEL_SERVER:
      return {
        data,
        pageType,
        queryString
      };
    default:
      return state;
  }
}
